module.exports = __webpack_public_path__ + "img/category-new-released-hover.c23f27e1.png";